import script from "./ButtonTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonTab.vue?vue&type=script&lang=ts&setup=true"

import "./ButtonTab.vue?vue&type=style&index=0&id=6e8543b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8543b8"]])

export default __exports__